module.exports = __webpack_public_path__ + "img/galerie-40.9282816c.jpg";